import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import type {
  AmcVisit,
  CompleteAmcVisitRequest,
} from "features/AmcVisitLogs/types/amc-visit.types";

interface CompleteVisitModalProps {
  show?: boolean;
  onCompleteClick?: (body: CompleteAmcVisitRequest) => void | Promise<void>;
  onCloseClick?: () => void;
  record?: AmcVisit | null;
}

const CompleteVisitModal = ({
  show,
  onCompleteClick,
  onCloseClick,
  record,
}: CompleteVisitModalProps) => {
  const [remarks, setRemarks] = useState("");

  useEffect(() => {
    if (show) {
      setRemarks("");
    }
  }, [show, record?.id]);

  const handleSubmit = () => {
    if (!record) return;
    const body: CompleteAmcVisitRequest = {};
    const r = remarks.trim();
    if (r) body.completionRemarks = r;
    void onCompleteClick?.(body);
  };

  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered>
      <ModalHeader className="modal-title">#{record?.code}</ModalHeader>
      <ModalBody className="p-4">
        <div className="text-center mb-3">
          <i className="bx bxs-badge-check display-5 text-success" />
        </div>
        <h4 className="mb-3 text-center">Complete service visit</h4>
        <p className="text-muted mb-3 text-center small">
          Once completed, this visit cannot be edited. Confirm details below,
          then complete.
        </p>

        <div className="mb-3">
          <Label className="form-label" for="complete-remarks">
            Completion remarks{" "}
            <span className="text-muted fw-normal">(optional)</span>
          </Label>
          <Input
            id="complete-remarks"
            type="textarea"
            rows={2}
            placeholder="Notes recorded with completion…"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </div>

        <div className="hstack gap-2 justify-content-center pt-2">
          <Button color="light" type="button" onClick={onCloseClick}>
            Back
          </Button>
          <Button color="success" type="button" onClick={handleSubmit}>
            Complete visit
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default CompleteVisitModal;
